import styled from "styled-components";
import { MdLocalBar } from "react-icons/md";
import { Rotate } from "../shared";
import { colors } from "../../colors";

export const MargLoader = styled(MdLocalBar)`
  animation: ${Rotate} 2s infinite;
  color: ${colors.secondary};
`;
